// https://github.com/reactjs/react-router/blob/master/docs/guides/ServerRendering.md
// https://github.com/reactjs/react-router-redux/blob/master/examples/server/client.js

/* eslint-disable-next-line import/first */
import executeTime from './utils/js_execution_util';

/* eslint-disable import/first */
import P from 'bluebird';
import 'lazysizes';
import React from 'react';
import { render } from 'react-dom';
import createHistory from 'history/createBrowserHistory';
import { matchRoutes } from 'react-router-config';
import Root from '../views/containers/root_container';
import { trackGAEvent } from './utils/third_party_js_util';
/* eslint-enable import/first */

// eslint-disable-next-line import/extensions
// import 'autotrack/autotrack.js';
import './utils/global_util';
import configureStore from '../redux/store/store';
import getRoutesWithStore from '../react_router/react_router';
import initialize from './utils/initializer_util';
import initialLoadActionCreator from '../redux/action_creators/initial_load_action_creator';
import log from './services/logger_service';
import cachingService from './services/caching_service';
import polyfillUtil from './utils/picture_polyfill_util';

initialize().catch(function logError(err) {
  log.error(err, 'Caught error in initialize.');
});

const browserHistory = createHistory();

const originalHash = browserHistory.location.hash;

browserHistory.location.hash = '';

// get json here
let bootstrappedConfig = false;
let env = false;
const config = document.querySelector('.client-config');

try {
  bootstrappedConfig = JSON.parse(config.getAttribute('data-state'));
  env = bootstrappedConfig.config.env;
  if (env !== 'development') {
    const criticalCss = document.querySelector('.critical-css');
    bootstrappedConfig.config.criticalCss = criticalCss.innerHTML;
  }
  cachingService.initialize(bootstrappedConfig.config.cacheEnabled);
  log.initialize(bootstrappedConfig); // TODO: send, site etc for errors
  browserHistory.location.key = bootstrappedConfig.routing.location.key;
} catch (error) {
  log.fatal(error, 'Fatal error parsing bootstrap json.');
}

if (!bootstrappedConfig) {
  bootstrappedConfig = {}; // TODO: default bootstrap to handle errors
}
const store = configureStore(browserHistory, bootstrappedConfig, env);
const routesToMatch = getRoutesWithStore(store);
polyfillUtil();

browserHistory.listen((location /* , action */) => {
  const url = `${location.pathname}`;
  const branch = matchRoutes(routesToMatch, url);
  branch.map(function matchMap({ route, match }) {
    if (route.loadData) {
      if (!route.autoScrollOff) {
        window.scrollTo(0, 0);
      }
      return route.loadData(match);
    }
    return P.resolve(null);
  });
});

function renderedApp() {
  store.dispatch(initialLoadActionCreator());
  browserHistory.location.hash = originalHash;
  const eventCategory = `performance`;
  const eventAction = `js_execution`;
  const eventLabel = executeTime();
  trackGAEvent({
    eventCategory,
    eventAction,
    eventLabel
  });
}

render(
  <Root store={store} history={browserHistory} />,
  window.document,
  renderedApp
);

if (module.hot) {
  module.hot.accept(
    ['../react_router/react_router', '../views/containers/root_container'],
    () => {
      // eslint-disable-next-line global-require
      const HotLoadRoot = require('../views/containers/root_container').default;
      render(
        <HotLoadRoot store={store} history={browserHistory} />,
        window.document
      );
    }
  );
}



// WEBPACK FOOTER //
// ./src/client/index.js